<script setup>
import { use18n } from 'src/utils/v2_helper/common';
import { ref, computed } from 'vue';

const { $t } = use18n();

const visible = ref(false);
const steps = ref([
  {
    text: computed(() => $t('home.howtostep1')),
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/how-step1.png',
  },
  {
    text: computed(() => $t('home.howtostep2')),
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/how-step2.png',
  },
  {
    text: computed(() => $t('home.howtostep3')),
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/how-step3.png',
  },
]);
</script>
<template>
  <div class="hpromo">
    <div class="hpromo-btn">
      <span class="hpromo-btn-icon iconfont dm-Confirmforpopup" />
      <div>{{ $t('home.howtoorder') }}</div>
      <div class="hpromo-btn-text" @click="visible = true">
        {{ $t('home.seeTuori') }}
      </div>
    </div>
    <q-dialog v-model="visible" position="bottom">
      <div class="vlist pc-width-pull-full">
        <header class="vlist-head">
          <span bold>{{ $t('home.howtoorder') }}</span>
          <i class="iconfont dm-close" @click="visible = false" />
        </header>
        <main class="vlist-main">
          <div v-for="it of steps" :key="it.text" class="step">
            <div>{{ it.text }}</div>
            <img :src="it.img" />
          </div>
        </main>
      </div>
    </q-dialog>
  </div>
</template>
<style lang="scss" scoped>
.hpromo {
  margin: 12px 24px 0;
  &-btn {
    display: flex;
    align-items: center;
    border-radius: $border-radius-3;
    background: #fff;
    padding-left: 16px;
    height: 48px;
    font-size: $font-size-1;
    margin-bottom: 4px;
    &-icon {
      margin-right: 8px;
      font-size: 16px;
      color: #6b7280;
    }
    &-text {
      margin-left: auto;
      padding-right: 16px;
      color: $primary;
      cursor: pointer;
      align-self: stretch;
      line-height: 48px;
    }
  }
}
.vlist {
  background: #fff;
  display: flex;
  flex-direction: column;
  &-head {
    font-size: $font-size-2;
    height: 64px;
    line-height: 64px;
    padding: 0 22px;
    background: #fff;
    display: flex;
    .iconfont {
      font-size: inherit;
      margin-left: auto;
    }
  }
  &-main {
    flex: 1;
    overflow: auto;
    padding: 16px;
    .step {
      font-weight: bold;
      margin-top: 24px;
      &:first-child {
        margin-top: 0;
      }
      img {
        margin-top: 12px;
        width: 100%;
      }
    }
  }
}
</style>
